import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { claimService } from "../../../../api/services/claimService";
import {
  setAirticketLaoder,
  setAllAirTickets,
} from "../../../../infra/aggregates/myProfile/claimAggregates/airTicketsSlice";

interface PropsValues {
  setAirTicketsData: (data: any) => void;
}

function DTOAirTickets({ setAirTicketsData }: PropsValues) {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state.authSlice);
  const storeAirTickets = useAppSelector(
    (state) => state.airTicketsSlice.airTickets
  );
  async function getAllAirTickets(empId: number, companyId: number) {
    dispatch(setAirticketLaoder(true));
    const response = await claimService.getAllAirTickets(empId, companyId);
    if (response) {
      dispatch(setAllAirTickets(response?.data));
      setAirTicketsData(response?.data);
      dispatch(setAirticketLaoder(false));
    } else {
      dispatch(setAirticketLaoder(false));

      return;
    }
  }
  useEffect(() => {
    if ((selector.emp_id, selector.company_id))
      getAllAirTickets(selector.emp_id, selector.company_id);
  }, []);

  useEffect(() => {
    setAirTicketsData(storeAirTickets);
  }, [storeAirTickets]);

  return <></>;
}
export default DTOAirTickets;
